import React from 'react';
import { Backdrop, Fade, Modal, Paper, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';
import i18next from 'i18next';
const useStyles = makeStyles()(theme => {
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      height: 'auto',
      border: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      padding: '2rem 3rem',
    },
  };
});

const RecommendationChart = ({ open, closeHandler, graphData }) => {
  const { classes } = useStyles();
  const theme = useTheme();

  const resultArray = [];

  resultArray.push({
    name: 'Ref price',
    value: Math.round(graphData?.ref_price),
    pv: 0,
  });

  resultArray.push({
    name: 'Extra tire cost',
    value: Math.round(graphData?.extra_tire_cost),
    pv: resultArray[0].pv + resultArray[0].value, // sum of previous pv and value
  });

  // Position 2:
  resultArray.push({
    name: 'Reduction fuel cost tire performance',
    value: Math.round(-graphData?.reduction_fuel_cost_tire_performance),
    pv: resultArray[1].pv + resultArray[1].value, // sum of previous pv and value
  });

  // Position 3: future_tco
  resultArray.push({
    name: 'Future tco',
    value:
      Math.round(graphData?.future_tco) ??
      resultArray[0].value +
        resultArray[1].value -
        Math.abs(resultArray[2].value),
    pv: 0,
  });

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={closeHandler}
      closeAfterTransition
      slots={Backdrop}
      slotProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Paper className={classes.paper}>
          <BarChart
            width={800}
            height={500}
            data={resultArray}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='name' />
            <YAxis
              tickFormatter={value =>
                i18next.language === 'de'
                  ? `${value.toLocaleString('de-DE')} €`
                  : `€ ${value.toLocaleString('en')}`
              }
            />
            <Tooltip
              formatter={value =>
                i18next.language === 'de'
                  ? `${value.toLocaleString('de-DE')} €`
                  : `€ ${value.toLocaleString('en')}`
              }
            />
            <Bar dataKey='pv' stackId='a' fill='transparent' />
            <Bar dataKey='value' stackId='a' fill={theme.palette.primary.main}>
              {resultArray.map((item, index) => {
                if (item.value < 0) {
                  return <Cell key={index} fill='#FF4500' />;
                }

                return <Cell key={index} fill={theme.palette.primary.main} />;
              })}
            </Bar>
          </BarChart>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default RecommendationChart;
